<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-28 14:07:12
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-28 16:48:01
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/cooperativeColonel/list/components/tableCell/tableCount.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>{{ row[column.tableKey] | formatEmpty | formatPrice2 }}</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
};
</script>
